import {
  Component,
  OnInit,
  HostListener,
  ViewEncapsulation,
  HostBinding,
  ChangeDetectorRef,
  NgZone,
} from "@angular/core";

import { BfxAuthService } from "./bfx-common/services/bfx-auth.service";
import { BfxSystemMessageService } from "./bfx-common/services/bfx-system-message.service";
import { TranslateService } from "@ngx-translate/core";

import {
  CubiqWorker,
  HeartBeatMonitor,
  AccountPromiseLookupService,
  OpsIntPromiseLookupService,
  InterventionDataPromiseLookupService,
  ClientPromiseLookupService,
  SystemControlPromiseLookupService,
  OrderAuditPromiseService,
  RateSubscriptionPromiseService,
  RatePromiseService,
  OrderRecapPromiseService,
  OrderDataPromiseLookupService,
  OrderLifecycleRateSubscriptionSource,
  RateSourcePromiseLookupService,
  TraderGroupPromiseLookupService,
  AlgoStrategyPromiseLookupService,
  FixingSourcePromiseLookupService,
  SalesGroupPromiseLookupService,
  CcyPromiseLookupService,
  ProfilePromiseActionService,
  CcyPairPromiseLookupService,
  PublicProfilePromiseActionService,
  VwapPromiseService,
  SystemConfigPromiseService,
  BlotterDefinitionPromiseLookupService,
  UserPromiseLookupService,
  CurrencyPairGroupPromiseLookupService,
  CurrencyPairCalendarPromiseLookupService,
  BlotterFilterPromiseLookupService,
  PositionBookPromiseLookupService,
  TimezonePromiseLookupService,
  BranchPromiseLookupService,
  BfxBlotterOrdersContextMenuPromiseService,
  BfxFindOrdersContextMenuPromiseService,
  DetailedOrderStatusRequestPromiseService,
  OrderAcceptancePromiseService,
  ClientActionPromiseService,
  FindActionPromiseService,
  OrderSalesApprovalRequestPromiseService,
  OrderXferPromiseService,
  OrderDataActionPromiseService,
  OrderQueryRequestPromiseService,
  MarketTimePromiseLookupService,
  TradeDealPromiseService,
  TradeDealPromiseLookupService,
  TradeDealPromiseActionService,
  ActiveUserProfilePromiseService,
  ScratchPadDataPromiseLookupService,
  MarkupPromiseService,
  FillTolerancePromiseService,
  SystemMessagePromiseService,
  AlgoHedgeConfigService,
  ManualPriceActionPrimaryService,
  InflightAlertNotificationService,
  VolumePerMinuteService,
  CustomFieldPromiseLookupService,
} from "shared/cubiq-services";

import { ScratchPadDataActionPrimaryService } from "../shared/cubiq-services/action/impl/ScratchPadDataActionPrimaryService";
import { NativeDesktopSupport } from "./bfx-native-desktop/native-desktop-support";
import { BmarkFixingsManagerService } from "./bfx-bmark-summary/services/bmark-fixings-manager.service";
import { BfxSysConfigUtilService } from "shared/auth-services";

import { LoggerService } from "@bfx/logger";
import { OrderTemperatureService } from "../shared/cubiq-services/lookup/pricing/impl/OrderTemperatureService";
import { ConnectionStatusPromiseService } from "shared/broker-client-services";
import { UserAuthPromiseService } from "../shared/cubiq-services/auth/impl/UserAuthPromiseService";
import { LoaderService } from "./bfx-auth/loader.service";
import { OmsPlatformOrders } from "./oms-platform-orders/oms-platform-orders";
import { NotificationTradeDealPrimaryLookupService } from "../shared/cubiq-services/lookup/model/impl/NotificationTradeDealPrimaryLookupService";

const logger = LoggerService.for(__dirname);

const FADE_IN_TIMEOUT = 5000;
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class AppComponent implements OnInit {
  // private bfxnamespaceready: boolean = false;
  public nativeDesktop = false;

  @HostBinding("class.ready-visibility-hook")
  public readonly readyVisibilityHook: boolean = true;

  @HostBinding("class.delay-fade-in")
  public delayFadeIn: boolean = true;

  public oms: boolean = false;

  constructor(
    private _cubiqWorker: CubiqWorker,
    private _heartBeatMonitor: HeartBeatMonitor,
    private _accountPromiseLookupService: AccountPromiseLookupService,
    private _clientPromiseLookupService: ClientPromiseLookupService,
    private _interventionPromiseLookupService: InterventionDataPromiseLookupService,
    private _opsInterventionPromiseLookupService: OpsIntPromiseLookupService,
    private _systemControlPromiseLookupService: SystemControlPromiseLookupService,
    private _orderAuditPromiseService: OrderAuditPromiseService,
    private _userAuthPromiseService: UserAuthPromiseService,
    private _rateSubscriptionPromiseService: RateSubscriptionPromiseService,
    private _ratePromiseService: RatePromiseService,
    private _orderRecapPromiseService: OrderRecapPromiseService,
    private _orderDataPromiseLookupService: OrderDataPromiseLookupService,
    private _orderLifecycleRateSubscriptionSource: OrderLifecycleRateSubscriptionSource,
    private _traderGroupPromiseLookupService: TraderGroupPromiseLookupService,
    private _rateSourcePromiseLookupService: RateSourcePromiseLookupService,
    private _algoStrategyPromiseLookupService: AlgoStrategyPromiseLookupService,
    private _fixingSourcePromiseLookupService: FixingSourcePromiseLookupService,
    private _salesGroupPromiseLookupService: SalesGroupPromiseLookupService,
    private _ccyPromiseLookupService: CcyPromiseLookupService,
    private _ccyPairPromiseLookupService: CcyPairPromiseLookupService,
    private _profilePromiseActionService: ProfilePromiseActionService,
    private _publicProfilePromiseActionService: PublicProfilePromiseActionService,
    private _vwapPromiseService: VwapPromiseService,
    private _systemConfigPromiseService: SystemConfigPromiseService,
    private _userLookupService: UserPromiseLookupService,
    private _blotterDefinitionLookupService: BlotterDefinitionPromiseLookupService,
    private _currencyPairGroupLookupService: CurrencyPairGroupPromiseLookupService,
    private _currencyPairCalendarPromiseLookupService: CurrencyPairCalendarPromiseLookupService,
    private _blotterFilterLookupService: BlotterFilterPromiseLookupService,
    private _positionBookPromiseLookupService: PositionBookPromiseLookupService,

    // Timezone lookup
    private _timezonePromiseLookupService: TimezonePromiseLookupService,
    // Branch lookup
    private _branchPromiseLookupService: BranchPromiseLookupService,
    // Connection Status
    private _connectionStatusPromiseService: ConnectionStatusPromiseService,
    //
    private _bfxBlotterOrdersContextMenuService: BfxBlotterOrdersContextMenuPromiseService,
    //
    private _bfxFindOrdersContextMenuService: BfxFindOrdersContextMenuPromiseService,
    // order actions
    private _detailedOrderStatusRequestPromiseService: DetailedOrderStatusRequestPromiseService,
    private _orderAcceptancePromiseService: OrderAcceptancePromiseService,
    private _clientActionPromiseService: ClientActionPromiseService,
    private _findActionPromiseService: FindActionPromiseService,
    private _orderSalesApprovalPromiseService: OrderSalesApprovalRequestPromiseService,
    private _orderXferPromiseService: OrderXferPromiseService,
    private _orderDataActionPromiseService: OrderDataActionPromiseService,
    private _scratchPadDataActionPrimaryService: ScratchPadDataActionPrimaryService,
    private _orderQueryRequestPromiseService: OrderQueryRequestPromiseService,
    // Trade Deal
    private _marketTimePromiseLookupService: MarketTimePromiseLookupService,
    private _tradeDealPromiseService: TradeDealPromiseService,
    private _tradeDealPromiseLookupService: TradeDealPromiseLookupService,
    private _tradeDealPromiseActionService: TradeDealPromiseActionService,
    // ActiveUser
    private _activeUserProfilePromiseService: ActiveUserProfilePromiseService,
    //ScratchPad
    private scratchPadPromiseService: ScratchPadDataPromiseLookupService,
    // Manual Price
    private _manualPriceActionPrimaryService: ManualPriceActionPrimaryService,

    private _markupPromiseService: MarkupPromiseService,
    private _fillTolerancePromiseService: FillTolerancePromiseService,
    private _systemMessagePromiseService: SystemMessagePromiseService,
    private _algoHedgeConfigService: AlgoHedgeConfigService,
    private _inflightAlertNotificationService: InflightAlertNotificationService,
    private _volumePerMinuteService: VolumePerMinuteService,

    private _translateService: TranslateService,
    private _authService: BfxAuthService,
    private _systemMessageService: BfxSystemMessageService,
    private _cd: ChangeDetectorRef,
    private _zone: NgZone,
    // initialize
    private _bmarkManager: BmarkFixingsManagerService,
    private _sysConfigUtil: BfxSysConfigUtilService,
    private orderTemperatureService: OrderTemperatureService,
    private _customFieldPromiseLookupService: CustomFieldPromiseLookupService,
    private _notificationTradeDeal: NotificationTradeDealPrimaryLookupService,
    private _loaderService: LoaderService,
  ) {
    logger.out.info(`${this.constructor.name}() angular bootstrapped`);
  }

  ngOnInit() {
    this._translateService.use("en");
    this._translateService.setDefaultLang("en");

    logger.out.info(`${this.constructor.name}() ngOnInit bootstrapped`);

    this.nativeDesktop = NativeDesktopSupport.initNativeDesktop();
    NativeDesktopSupport.initialize(this._zone);

    try {
      Notification.requestPermission().then((result) => {
        if (result === "denied") {
          logger.out.warn("Notification Permission wasn't granted. Logging may be degraded.");
          return;
        }
        if (result === "default") {
          logger.out.warn("Notification Permission was ignored. Logging may be degraded.");
          return;
        }
        if (result === "granted") {
          logger.out.info("Notification Permission was granted.");
          return;
        }
      });
    } catch (e) {
      logger.out.warn(`Notification Permission failed ${e}. Logging may be degraded.`);
    }

    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      Promise.race([
        NativeDesktopSupport.nativeWindowFadeIn,
        new Promise<void>((res) => {
          setTimeout(() => {
            res();
          }, FADE_IN_TIMEOUT);
        }),
      ]).then(() => {
        requestAnimationFrame(() => {
          this.delayFadeIn = false;
        });
      });
    } else {
      this.delayFadeIn = false;
    }
  }

  @HostListener("window:beforeunload")
  public onAppReload(): void {
    if (this.nativeDesktop) {
      NativeDesktopSupport.closeAllWindows();
    }
  }

  @HostListener("body:contextmenu", ["$event"])
  public handleDefaultContextMenu(): boolean {
    // context menus are always explict
    return false;
  }

  componentRemoved($event: object) {
    if ($event != null && $event instanceof OmsPlatformOrders) {
      this.oms = false;
    }
  }

  componentAdded($event: object) {
    if ($event != null && $event instanceof OmsPlatformOrders) {
      this.oms = true;
    }
  }
}
